import { Operation, removeUnavailableDocumentsFromState, SalesDocumentConnection, State } from "@icc/b2b/shared/worker";
import { idbService } from "./worker-db";
import { workerState } from "./worker-state";
import { SyncConfig } from "./sync-config";
import { rebuildMerkleTrees } from "./tree";

export async function flagUnavailableDocuments(opsOfUnavailableDocs: Operation[], state: State, unavailableDocs: string[] = [], updateIdb = true) {
    const flaggedOps: Operation[] = [];
    for (const op of state.operations) {
        if (unavailableDocs.includes(op.docId) || 'buyDocId' in op && unavailableDocs.includes(op.buyDocId)) {
            op.del = (op.del ?? 0) + (unavailableDocs.includes(op.docId) ? 1 : 0) + ('buyDocId' in op && unavailableDocs.includes(op.buyDocId) ? 1 : 0);
        }
    }
    for (const op of opsOfUnavailableDocs) {
        if (unavailableDocs.includes(op.docId) || 'buyDocId' in op && unavailableDocs.includes(op.buyDocId)) {
            op.del = (op.del ?? 0) + (unavailableDocs.includes(op.docId) ? 1 : 0) + ('buyDocId' in op && unavailableDocs.includes(op.buyDocId) ? 1 : 0);
            flaggedOps.push(op);
        }
    }

    const flaggedDocumentConnections: SalesDocumentConnection[] = [];
    for (const docId in state.documentConnections) {
        for (const buyDocId in state.documentConnections[docId]) {
            if (unavailableDocs.includes(docId) || unavailableDocs.includes(buyDocId)) {
                for (const uuid in state.documentConnections[docId][buyDocId]) {
                    state.documentConnections[docId][buyDocId][uuid].$del = (state.documentConnections[docId][buyDocId][uuid].$del ?? 0) + 1;
                    flaggedDocumentConnections.push(state.documentConnections[docId][buyDocId][uuid]);
                }
            }
        }
    }

    if (flaggedOps.length && updateIdb) {
        await idbService.saveMany('ops', flaggedOps);
    }
    if (flaggedDocumentConnections.length && updateIdb) {
        await idbService.saveMany('document_connections', flaggedDocumentConnections);
    }
}

export async function unflagDocuments(state: State, unavailableDocs: string[] = []) {
    const ops: Operation[] = await idbService.getManyOps(unavailableDocs);
    const flaggedOps: Operation[] = [];
    for (const op of state.operations) {
        if (op.del > 0 && (unavailableDocs.includes(op.docId) || 'buyDocId' in op && unavailableDocs.includes(op.buyDocId))) {
            op.del = 0;
        }
    }
    for (const op of ops) {
        if (op.del > 0 && (unavailableDocs.includes(op.docId) || 'buyDocId' in op && unavailableDocs.includes(op.buyDocId))) {
            op.del = 0;
            flaggedOps.push(op);
        }
    }
    const flaggedDocumentConnections: SalesDocumentConnection[] = [];
    for (const docId in state.documentConnections) {
        for (const buyDocId in state.documentConnections[docId]) {
            if (unavailableDocs.includes(docId) || unavailableDocs.includes(buyDocId)) {
                for (const uuid in state.documentConnections[docId][buyDocId]) {
                    state.documentConnections[docId][buyDocId][uuid].$del = 0;
                    flaggedDocumentConnections.push(state.documentConnections[docId][buyDocId][uuid]);
                }
            }
        }
    }

    if (flaggedOps.length) {
        await idbService.saveMany('ops', flaggedOps);
    }
    if (flaggedDocumentConnections.length) {
        await idbService.saveMany('document_connections', flaggedDocumentConnections);
    }
}

export async function removeDocumentsFromDB(docs: string[], syncConfig: SyncConfig) {
    const ops: Operation[] = await idbService.getManyOps(docs);
    await flagUnavailableDocuments(ops, workerState, docs);
    await idbService.removeDocumentPermanently(docs, syncConfig.userId);
    removeUnavailableDocumentsFromState(workerState, docs);
    rebuildMerkleTrees(docs, workerState.operations, syncConfig.userId, true);
    await unflagDocuments(workerState, docs);
}
